import API from './api'


const SHIPPING_api_token = process.env.REACT_APP_CLICKSHIP_TOKEN;
const SHIPPING_api_path = process.env.REACT_APP_CLICKSHIP_API_URL;
const SHIPPING_api_payment_id = process.env.REACT_APP_CLICKSHIP_PAYMENT_ID

const getHeaders = () => {
    
    return { 'Authorization': SHIPPING_api_token,
             'Content-Type': 'application/json'
     }
}

export const getShipment = (shipment_id) => {
    return API.get(SHIPPING_api_path +`/shipment/${shipment_id}` ,{ headers: getHeaders() })
}
export const deleteShipment = (shipment_id) => {
    return API.delete(SHIPPING_api_path +`/shipment/${shipment_id}` ,{ headers: getHeaders() })
}
export const trackingShipment = (shipment_id) => {
    return API.get(SHIPPING_api_path +`/shipment/${shipment_id}/tracking-events` ,{ headers: getHeaders() })
}
export const pickupSchedule = (shipment_id, obj) => {
    return API.post(SHIPPING_api_path +`/shipment/${shipment_id}/schedule/`,obj ,{ headers: getHeaders() })
}
export const cancelSchedulePickup = (shipment_id) => {
    return API.delete(SHIPPING_api_path +`/shipment/${shipment_id}/schedule/`,{ headers: getHeaders() })
}
export const getSchedulePickup = (shipment_id) => {
    return API.get(SHIPPING_api_path +`/shipment/${shipment_id}/schedule/`,{ headers: getHeaders() })
}